goog.provide('el8.util.amplitude.documentHelpers');

goog.require('el8.util.amplitude.helpers');

/**
 * Amplitude log the importing of documents from fax import and patient chart
 *
 * @param {string} source - string of the where the log is called from
 * @param {object} documentMap - mapped object of the incoming document
 * @param {Date} start - the starting time of the uploading of the files
 */
el8.util.amplitude.logFileDocument = function(source, documentMap, start) {
    el8.util.amplitude.logEvent('file document to patient chart', {
        source: source,
        'document type': documentMap.document_type,
        'number of tags': (documentMap.doc_tags || []).length,
        'number of pages': (documentMap.file_ids ? documentMap.file_ids.length : 1),
        'upload time': Math.ceil((new Date() - start) / 1000),
        'title': Boolean(documentMap.custom_title),
        'linked to order': Boolean(documentMap.order_to_link),
        'manual lab trending': Boolean(documentMap.lab_values),
        'urgent': documentMap.is_urgent,
        'file on behalf of reviewer': documentMap.is_signed_off
    });
}

/**
 * Amplitude log the viewing of recently deleted faxes from fax import
*/
el8.util.amplitude.logViewRecentlyDeletedFaxes = function() {
    el8.util.amplitude.logEvent('View recently deleted faxes');
}

/**
 * Amplitude log the restoring of recently deleted faxes from fax import
 * 
 *  * @param {number} pageCount - count of pages being restored
 */
el8.util.amplitude.logRestoreDeletedFax = function(pageCount) {
    el8.util.amplitude.logEvent('Restore deleted fax from Fax Inbox', {'page count': pageCount});
}
